const LEADING_VERBS = [
  'Led',
  'Built',
  'Developed',
  'Engineered',
  'Implemented',
  'Deployed',
  'Integrated',
  'Migrated',
  'Enhanced',
  'Designed',
  'Architected',
  'Created',
  'Established',
  'Automated',
  'Optimized',
];

export function isEmailLike(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

export function sanitizeHiringManager(value?: string): string | undefined {
  const trimmed = value?.trim();
  if (!trimmed) return undefined;
  if (isEmailLike(trimmed) || trimmed.includes('@')) return undefined;
  if (/^https?:\/\//i.test(trimmed)) return undefined;
  return trimmed;
}

/** Convert resume bullet / project line to natural first person ("I led...", "I built..."). */
export function toFirstPerson(text: string): string {
  const cleaned = text.replace(/\.$/, '').trim();
  if (!cleaned) return '';

  if (/^I\b/.test(cleaned)) return cleaned;

  for (const verb of LEADING_VERBS) {
    const pattern = new RegExp(`^${verb}\\b`, 'i');
    if (pattern.test(cleaned)) {
      return cleaned.replace(pattern, `I ${verb.toLowerCase()}`);
    }
  }

  if (/^(a|an|the)\b/i.test(cleaned)) {
    return `I contributed to ${cleaned}`;
  }

  return `I ${cleaned.charAt(0).toLowerCase()}${cleaned.slice(1)}`;
}

export function embedAdaptabilityQuote(quote: string): string {
  const sentence = quote.replace(/\.$/, '').trim();
  if (/^I\b/.test(sentence)) {
    return `I'm comfortable ramping quickly on new tools when the problem requires it. ${sentence}`;
  }
  return `I'm comfortable ramping quickly on new tools when the problem requires it—${sentence.charAt(0).toLowerCase()}${sentence.slice(1)}.`;
}
